<template>

  <Header />

  <router-view />

  <Footer />
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { useSeo } from '@/services/Seo'

export default {
  name: 'App',
    components: {
      Header, Footer
    },
    setup() { useSeo() }
  } 
</script>